import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import {WORD_BOOKMARK_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';
import {WordService} from './word.service';


@Injectable({
  providedIn: 'root'
})
export class WordBookmarkService extends WordService {

  constructor(
    protected override api: ApiService,
  ) {
    super(api);
    this.urlApi = WORD_BOOKMARK_API_URL;
  }

  /**
   * 단어를 책갈피에 추가/삭제하는 프로토콜을 서버에 전송한다.
   * 화면(listWord)와는 관계 없다.
   * @param id: 추가할 단어번호
   * @param add: 추가/삭제 여부
   */
  public sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + id + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('sendBookmark', id, add, data);
        return data;
      }),
      // catchError((err, caught) => {
      //   console.error('sendBookmark', id, add, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }

  /**
   * 지정한 단어를 표시 목록에서 제거한다.
   * this.listWord에서 제거하면 화면에서 지워진다.
   * @param id: 제거할 단어번호
   */
  public hideBookmark(id: string): void {
    if (this.totalCount === null) {
      throw new Error('WordBookmarkService::hideBookmark() totalCount is null');
    }
    if (this.listWord === null) {
      throw new Error('WordBookmarkService::hideBookmark() listWord is null');
    }

    const idx = this.listWord.findIndex(word => word.id === id) ?? -1;
    if (idx !== -1) {
      this.listWord.splice(idx, 1);
      --this.totalCount;
    }
    else {
      console.warn(`WordBookmarkService::hideBookmark(${id}) word does not exist`);
    }
  }

}
